// ui.js

import store from '../store'

// Actions
const TOGGLE_BUSY_SECTION = 'TOGGLE_BUSY_SECTION'

// Reducer
export default function reducer(state = { busySections: {} }, action = {}) {
    switch (action.type) {
        case 'TOGGLE_BUSY_SECTION':
            return ({
                ...state,
                busySections: {
                    ...state.busySections,
                    [action.section]: typeof action.force !== 'undefined' && action.force !== null ? action.force : (!state.busySections[action.section]),
                },
            })
        default: return state
    }
}

// Action Creators
export const toggleBusySection = section => ({
    type: TOGGLE_BUSY_SECTION,
    section,
})

/**
 * Pass busy section inside store
 *
 * @param {string} section
 * @return {*}
 */
export const toggleBusySectionFunc = section => (
    store.dispatch(toggleBusySection(section))
)
